import script from "./TheTopBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./TheTopBanner.vue?vue&type=script&setup=true&lang=ts"

import "./TheTopBanner.vue?vue&type=style&index=0&id=28fe2ead&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28fe2ead"]])

export default __exports__